import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { findCategory } from "@/components/categories";
import { Timer } from "lucide-react";

export const formatDuration = (sec) => {
  const s = Math.round(sec);
  const m = Math.floor(s / 60);
  return m ? `${m} min ${String(s % 60).padStart(2, "0")} s` : `${s} s`;
};

const breakdown = (images, categories) => {
  const groups = new Map();
  images.forEach((img) => {
    const cat = findCategory(categories, img.category_id);
    const key = cat?.id || "";
    const g = groups.get(key) || { name: cat?.name || "Sans catégorie", color: cat?.color || "#64748b", total: 0, count: 0 };
    g.total += Number(img.duration) || 0;
    g.count += 1;
    groups.set(key, g);
  });
  return [...groups.values()];
};

export const CycleDuration = ({ images, categories }) => {
  if (!images.length) return null;
  const total = images.reduce((a, i) => a + (Number(i.duration) || 0), 0);
  const transitions = images.reduce((a, i) => a + (Number(i.transition_duration ?? 0.8) || 0), 0);
  return (
    <HoverCard openDelay={100}>
      <HoverCardTrigger asChild>
        <div className="hidden cursor-help items-center gap-1.5 whitespace-nowrap rounded-full border border-border bg-card px-3 py-1 text-xs md:flex" data-testid="cycle-duration">
          <Timer className="h-3.5 w-3.5 text-primary" />
          <span className="text-muted-foreground">Tour complet :</span>
          <span className="font-semibold" data-testid="cycle-duration-total">{formatDuration(total)}</span>
          <span className="text-muted-foreground">· {images.length} image{images.length > 1 ? "s" : ""}</span>
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-72" data-testid="cycle-duration-detail">
        <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">Détail par catégorie</p>
        <div className="space-y-1.5">
          {breakdown(images, categories).map((g) => (
            <div key={g.name} className="flex items-center justify-between text-sm">
              <span className="flex items-center gap-2"><span className="h-2.5 w-2.5 rounded-full" style={{ background: g.color }} />{g.name} <span className="text-xs text-muted-foreground">({g.count})</span></span>
              <span className="font-mono-label text-xs">{formatDuration(g.total)}</span>
            </div>
          ))}
        </div>
        <p className="mt-3 border-t border-border pt-2 text-[11px] text-muted-foreground">
          Dont {formatDuration(transitions)} de transitions (elles se font pendant la durée d'affichage).
        </p>
      </HoverCardContent>
    </HoverCard>
  );
};
